@if (tags.length) {
  <span class="ag-tags">
    @for (tag of tags; track tag.id) {
      <sui-badge [text]="tag.name" [variant]="'neutral'"></sui-badge>
    }
  </span>
} @else {
  <span class="empty-value">—</span>
}
